
<template>
  <div class="signup app-content bg-gray">
    <div class="container">
      <div class="row pt-4 ">
        <div class="col-12">
          <router-link :to="'./mypage'">
            <p class="text-dark font14 under" style="display: inline;">{{$t("message.top")}}</p>
          </router-link>
          <p class="mx-1 text-dark font14" style="display: inline;"> > </p>
          <router-link :to="'./accept_certificate'">
            <p class="text-dark font14 under" style="display: inline;">{{$t("message.visa_application")}}</p>
          </router-link>
        </div>
      </div>
      <div class="row mt-4">
        <div class="container my-5" >
          <h2 class="title text-center">{{$t("message.visa_application")}}</h2>
        </div>

         <div class="col-12 mb-5">
          <b-card>

            {{$t("message.technical_intern_training2")}}<br>
            {{$t("message.need_the_following")}}<br>
            {{$t("message.pass_certificate_test_specialized")}}<br>
            {{$t("message.technical_intern_training3")}}<br>
            {{$t("message.evaluation_record_technical_intern")}}<br>
            <div v-for='(technical_training_type, index) in technical_training_type_list' :key='index'>
              <select-file :fileURL='technical_training_type' :keyName='"technical_training_type"' :indexImage='index' @changeFile='changeFile'></select-file>
            </div>

            {{$t("message.cartificate_pass_basic_test")}}
            <div v-for='(technical_training_2_certificate, index) in technical_training_2_certificate_list' :key='"technical_training_2_certificate" + index'>
              <select-file :fileURL='technical_training_2_certificate' :keyName='"technical_training_2_certificate"' :indexImage='index' @changeFile='changeFile'></select-file>
            </div>

            <validation-provider ref="image8" >
              <div slot-scope="Image8Props">
                  {{$t("message.change_permission_application")}}
                  <select-file :fileURL='regist_info.japanese_language_proficiency_test_certificate' keyName='japanese_language_proficiency_test_certificate' @changeFile='changeFile'></select-file>
                  <p v-if="Image8Props.failed" class="error">{{ RerumeProps.errors[0] }}</p>
              </div>
              <p>1人で写っているもの・画質が綺麗なもの・影になっていないもの・顔がしっかりわかるもの・背景は必ず白</p>
            </validation-provider>

          </b-card>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';
import selectFile from "@/components/selectFile"
export default {
  components: {
    selectFile,
  },
  data () {
    return {
      user_accept: "",
      idToken: localStorage.idToken,
      fileValid: false,
      regist_info:{},
      taxation_certificate_list: [],
      withholding_certificate_list: [],
      technical_training_type_list: [],
      technical_training_2_certificate_list: [],
    }
  },
  methods: {
    isEmpty: function(str) {
        return (!str || 0 === str.length);
    },
    changeFile: function(data){
      if('taxation_certificate' == data.keyName){
        this.taxation_certificate_list[data.index] = data.fileImage
        this.taxation_certificate_list = this.taxation_certificate_list.concat()
        console.log(this.taxation_certificate_list)
      }
      else if('withholding_certificate' == data.keyName){
        this.withholding_certificate_list[data.index] = data.fileImage
        this.withholding_certificate_list = this.withholding_certificate_list.concat()
      }
      else if('technical_training_type' == data.keyName){
        this.technical_training_type_list[data.index] = data.fileImage
        this.technical_training_type_list = this.technical_training_type_list.concat()
      }
      else if('technical_training_2_certificate' == data.keyName){
        this.technical_training_2_certificate_list[data.index] = data.fileImage
        this.technical_training_2_certificate_list = this.technical_training_2_certificate_list.concat()
      }
      else{
        this.regist_info[data.keyName] = data.fileImage
        this.regist_info = Object.assign({},this.regist_info)
      }
    },
    regist(){
      this.fileValid = false
      this.regist_info['user'] = {'sub': this.memberInfo.sub}
      this.regist_info['taxation_certificate'] = this.taxation_certificate_list.join('!')
      this.regist_info['withholding_certificate'] = this.withholding_certificate_list.join('!')
      this.regist_info['technical_training_type'] = this.technical_training_type_list.join('!')
      this.regist_info['technical_training_2_certificate'] = this.technical_training_2_certificate_list.join('!')
      console.log(this.regist_info )
      axios
        .patch(process.env.VUE_APP_API + "/users/" + this.memberInfo.id, this.regist_info, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
          this.$store.commit('user/setUser', response.data)
          this.$swal.fire({
            icon: 'success',
            title: this.$i18n.t('message.change_success')
          })
        }).catch(error => {
          console.log('this is error', error)
        })

    },
  },
  computed: {
    ...mapState({
      user: state => state.user.outh,
      memberInfo: state => state.user.user
    }),
  },
  mounted(){
    this.$store.commit('setLoading', false)
    console.log(this.memberInfo)
    this.regist_info = this.memberInfo
    if( this.memberInfo.taxation_certificate != undefined){
      this.taxation_certificate_list = this.memberInfo.taxation_certificate.split(',')
    }
    while(this.taxation_certificate_list.length < 3){
      this.taxation_certificate_list.push('')
    }

    if( this.memberInfo.withholding_certificate != undefined){
      this.withholding_certificate_list = this.memberInfo.withholding_certificate.split(',')
    }
    while(this.withholding_certificate_list.length < 3){
      this.withholding_certificate_list.push('')
    }


    if( this.memberInfo.technical_training_type != undefined){
      this.technical_training_type_list = this.memberInfo.technical_training_type.split(',')
    }
    while(this.technical_training_type_list.length < 3){
      this.technical_training_type_list.push('')
    }


    if( this.memberInfo.technical_training_2_certificate != undefined){
      this.technical_training_2_certificate_list = this.memberInfo.technical_training_2_certificate.split(',')
    }
    while(this.technical_training_2_certificate_list.length < 3){
      this.technical_training_2_certificate_list.push('')
    }

    console.log(this.taxation_certificate_list)
    this.resume_image_url = this.memberInfo.resume_image
  },

}
</script>
